export function format(first: string, middle: string, last: string): string {
  return (first || '') + (middle ? ` ${middle}` : '') + (last ? ` ${last}` : '');
}

export const scrollToSection = (sectionId) => {

  const sectionIdUpdated = sectionId.startsWith('#') ? sectionId.substring(1) : sectionId;

  const section = document.querySelector(`[id='${sectionIdUpdated}']`);
  if (section) {
      section.scrollIntoView({ behavior: 'smooth' });
  }
}

export const convertToArray = <T>(arrayAsString:string ):Array<T> => {
  const array:any[] =  arrayAsString && arrayAsString.split(",");
  return array
} 

export const getQueryParamValue = (param: string): string | null => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param);
}